import * as React from "react";
import Session from "supertokens-auth-react/recipe/session";
import { getDeploymentDbInfo } from "../../api/saas/deployment/db/get";
import { Loading } from "../../components/elements";
import CopyBox from "../../components/elements/CopyBox";
import { getDbInfoForMultiTenantApp } from "../../api/saas/multi-tenancy/connection-uri-domain/appid/db/get";

interface Props {
    closeConnectPopup: () => void;
    appDeploymentId: string;
    deploymentId: string;
    copyClickCallback: Function;
    usesMultiTenancy: boolean;
}

type State =
    | {
        loaded: false;
        error?: any;
    }
    | {
        loaded: true;
        dbInfo: {
            dbHost: string;
            dbUser: string;
            dbPassword: string;
            dbName: string;
        };
    };

export default class DbConnectPopup extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            loaded: false
        };
    }

    stopPropagation(e: React.MouseEvent) {
        e.stopPropagation();
    }

    getDbInfo = async () => {
        if (!this.props.usesMultiTenancy) {
            return await getDeploymentDbInfo(this.props.deploymentId, this.props.appDeploymentId);
        }

        return await getDbInfoForMultiTenantApp({
            deploymentId: this.props.deploymentId,
            appId: this.props.appDeploymentId
        });
    }

    async componentDidMount() {
        const callapi = async () => {
            try {
                let doesSessionExist = await Session.doesSessionExist();
                if (doesSessionExist) {
                    const dbInfo = await this.getDbInfo();
                    this.setState({
                        loaded: true,
                        dbInfo
                    });
                } else {
                    window.location.reload();
                }
            } catch (ex) {
                this.setState(s => ({ loaded: false, error: ex }));
            }
        };

        callapi();
    }

    render() {
        return (
            <section className="dashboard-popup" onClick={this.props.closeConnectPopup}>
                <section className="content" onClick={this.stopPropagation}>
                    <div className="close-button" onClick={this.props.closeConnectPopup}>
                        <img src="static/assets/dashboard/close-icon-dark.png" alt="close" />
                    </div>
                    <h4>Connect to the database</h4>
                    <p>Information regarding your database is given below. You can use these to manually connect to the database and inspect / edit the information.</p>
                    {!this.state.loaded &&
                        (this.state.error ? <p>Something went wrong. Please try again later or contact us if the error persists.</p> : <Loading />)}
                    {this.state.loaded && (
                        <>
                            <div className="copy-box-with-label multiline">
                                <p className="copy-box-with-label__label">db host</p>
                                <CopyBox
                                    value={this.state.dbInfo.dbHost}
                                    copyCallback={() => this.props.copyClickCallback("db host")}
                                />
                            </div>
                            <div className="copy-box-with-label">
                                <p className="copy-box-with-label__label">db name</p>
                                <CopyBox
                                    value={this.state.dbInfo.dbName}
                                    copyCallback={() => this.props.copyClickCallback("db name")}
                                />
                            </div>
                            <div className="copy-box-with-label">
                                <p className="copy-box-with-label__label">db user</p>
                                <CopyBox
                                    value={this.state.dbInfo.dbUser}
                                    copyCallback={() => this.props.copyClickCallback("db user")}
                                />
                            </div>
                            <div className="copy-box-with-label">
                                <p className="copy-box-with-label__label">db password</p>
                                <CopyBox
                                    value={this.state.dbInfo.dbPassword}
                                    copyCallback={() => this.props.copyClickCallback("db password")}
                                />
                            </div>
                        </>
                    )}
                </section>
            </section>
        );
    }
}
